export default __webpack_public_path__ + "static/Fria_Curry-85c45c438cba85dd388f3678f618007d.png";